import { Contact } from '../../../domain/customerContact/Contact';
import { ViewDetails } from '../../shared/components/ViewDetails';
import Table from '../../shared/components/table/Table';

interface Props {
    data: Contact[];
    onSortingChange?: (columnName: string, sortOrder: 'asc' | 'desc') => void;
    sortedBy?: string | null;
    ascending?: boolean | null;
}

export default function ContactsTable({
    data: contacts,
    onSortingChange,
    sortedBy,
    ascending,
}: Props) {
    const triggerSortingChange = (columnName: string, sortOrder: 'asc' | 'desc') => {
        if (onSortingChange) onSortingChange(columnName, sortOrder);
    };

    return (
        <Table
            sortedBy={sortedBy}
            ascending={ascending}
            onSortingChange={triggerSortingChange}
            columns={[
                {
                    isSortable: true,
                    name: 'FirstName',
                    title: 'Nombre Completo',
                },
                { isSortable: true, name: 'Email', title: 'Correo Electrónico' },
                { isSortable: true, name: 'CellphoneNumber', title: 'Célular' },
                { isSortable: true, name: 'Position', title: 'Cargo' },
                { isSortable: false, name: 'Actions', title: '' },
            ]}
        >
            {contacts.map((contact) => (
                <tr key={contact.id}>
                    <td>
                        {contact.firstName} {contact.middleName} {contact.lastName}{' '}
                        {contact.surname}
                    </td>
                    <td>{contact.email}</td>
                    <td>{contact.cellphoneNumber}</td>
                    <td>{contact.position}</td>
                    <td>
                        <ViewDetails
                            href={'/customers/contacts/update-contact/' + contact.id}
                        />
                    </td>
                </tr>
            ))}
        </Table>
    );
}
